import { render } from "./RegionsOfChina.vue?vue&type=template&id=6356daa4"
import script from "./RegionsOfChina.vue?vue&type=script&lang=js"
export * from "./RegionsOfChina.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__